import { render, staticRenderFns } from "./Menu.vue?vue&type=template&id=28bd533c&scoped=true&"
var script = {}
import style0 from "./Menu.vue?vue&type=style&index=0&id=28bd533c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bd533c",
  null
  
)

export default component.exports